import { Tag, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import type { ScenarioTag } from "../types";

interface Props {
  tags: ScenarioTag[];
  activeTagId: string | null;
  onSelect: (tagId: string | null) => void;
}

export const TagScenarioBar = observer(({ tags, activeTagId, onSelect }: Props) => {
  if (tags.length === 0) return null;

  const sorted = [...tags].sort((a, b) => a.order - b.order);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
      <Typography.Text type="secondary" style={{ marginRight: 4 }}>Szenario:</Typography.Text>
      {sorted.map((tag) => (
        <Tag
          key={tag.id}
          color={activeTagId === tag.id ? tag.color : undefined}
          style={{
            cursor: "pointer",
            border: `2px solid ${tag.color}`,
            opacity: activeTagId !== null && activeTagId !== tag.id ? 0.5 : 1,
            fontWeight: activeTagId === tag.id ? 700 : 400,
            transition: "all 0.15s",
          }}
          onClick={() => onSelect(activeTagId === tag.id ? null : tag.id)}
        >
          {tag.name}
        </Tag>
      ))}
      {activeTagId && (
        <Typography.Link onClick={() => onSelect(null)} style={{ fontSize: 12 }}>
          Auswahl aufheben
        </Typography.Link>
      )}
    </div>
  );
});
